import { render, staticRenderFns } from "./ValueAdditionManufacturing.vue?vue&type=template&id=28b5f71a&scoped=true&"
import script from "./ValueAdditionManufacturing.vue?vue&type=script&lang=js&"
export * from "./ValueAdditionManufacturing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b5f71a",
  null
  
)

export default component.exports